import React, { useEffect, useState } from "react";
import { Box, Button } from "@mui/material";
import InputText from "../../components/InputText";
import { useFormik } from "formik";
import * as yup from "yup";
import Title from "../../components/Content/Title";
import { useDispatch, useSelector } from "react-redux";
import ContentType from "../../components/Content/ContentType";
import Category from "../../components/Content/Category";
import UploadMetaData from "../../components/Content/UploadMetaData";
import { generateClient } from "aws-amplify/api";
import { createContent, updateContent } from "../../graphql/mutations";
import { toast } from "react-toastify";
import { uploadData } from "aws-amplify/storage";
import Genre from "../../components/Content/Genre";
import { setLoading } from "../../redux/slices/apiSlice";
import Language from "../../components/Content/Language";
import Rating from "../../components/Content/Rating";
import ComplianceModal from "../../components/Content/ComplianceModal";
import moment from "moment";
import CsvFileInput from "../../components/Content/CSVUploader";
import { WATCH, LISTEN, READ, PLAY, DEVOTION, VODCAST, DREAMKIDS,SHORT_FILM } from "../../constants";
import SeriesHandler from "../../components/Content/SeriesHandler";
import AlbumHandler from "../../components/Content/AlbumHandler";
import StudioSelector from "../../components/Content/StudioSelector";
import {
	clearContentForm,
	handleComplianceOpen,
	submitSuccessfully,
} from "../../redux/slices/contentSlice/contentForm/contentForm";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
	setOMDbContent,
	setReadContent,
} from "../../redux/slices/contentSlice/apiContent";
import { resetOnedrive } from "../../redux/slices/contentSlice/onedriveContent/onedriveContent";
import { post } from "aws-amplify/api";
import MediaTypeSelector from "../../components/Content/MediaSelector";
import IsDevotionMultiple from "../../components/Content/IsDevotionMultiple";
import BatchDevotionHandler from "../../components/Content/BatchDevotionHandler";
import {
	handleBack,
	handleComplete,
	handleNext,
	handleReset,
} from "../../redux/slices/addNewContentStepsSlice";
import Selector from "../../components/Selector";
import ReadOnlyInput from "../../components/ReadOnlyInput";
import { getAgreement } from "../../graphql/queries";
import ManifestPreview from "../../components/ManifestPreview";
import { handleSuccessState } from "../../redux/slices/success";
import UploadMultipleSongs from "../../components/Content/UploadMultipleSongs";
import ContentSuccessModal from "../../components/ManifestPreview/ContentSuccessModal";
import { validateCSVHeaders } from "../../helper/csvHeaders";
import UploadSeasonContent from "../../components/Content/UploadSeasonContent";
import UploadEpisodes from "../../components/Content/UploadEpisodes";
import NavigationWarningModal from "../../components/NavigationWarningModal";
import Country from '../../components/countries'

const CreateContent = () => {
	const client = generateClient();
	const dispatch = useDispatch();

	//content form states
	const contentSubmittedSuccessfully = useSelector(
		(state) => state.contentForm.submittedSuccessfully
	);
	const contentForm = useSelector((state) => state.contentForm);
	const albumId = useSelector((state) => state.contentForm.albumId);
	const complianceChecked = useSelector(
		(state) => state.contentForm.complianceChecked
	);
	const complianceOpen = useSelector(
		(state) => state.contentForm.complianceOpen
	);
	const isSeries = useSelector((state) => state.contentForm.isSeries);
	const isAlbum = useSelector((state) => state.contentForm.isAlbum);
	const isDevotionMultiple = useSelector(
		(state) => state.contentForm.isDevotionMultiple
	);
	const selectedSeasonsList = useSelector(
		(state) => state.contentForm.selectedSeasonsList
	);
	const submittedSuccessfully = useSelector(
		(state) => state.contentForm.submittedSuccessfully
	);

	//API Content States
	const OMDbContent = useSelector((state) => state.apiContent.OMDbContent);
	const readContent = useSelector((state) => state.apiContent.readContent);
	const listenContent = useSelector(
		(state) => state.apiContent.listenContent
	);
	const loading = useSelector((state) => state.api.loading);

	const selectedOneDriveFiles = useSelector(
		(state) => state.oneDriveContent.selectedOneDriveFiles
	);

	const agreementDetails = useSelector((state) => state.agreementForm);
	const addNewContentSteps = useSelector((state) => state.addNewContentSteps);
	const numberOfRefreshCycles = agreementDetails?.numberOfRefreshCycles;

	const [csvData, setCSVData] = useState(null);

	const location = useLocation();
	const isEditMode = location.pathname.includes("edit");

	let cyclesOptions = [];

	for (let i = 0; i < numberOfRefreshCycles; i++) {
		cyclesOptions.push({ value: i + 1, label: i + 1 });
	}

	//Content Success Modal Handling
	const handleSuccessModal = () => {
		dispatch(submitSuccessfully(true));
	};
	const handleCloseModal = () => {
		dispatch(submitSuccessfully(false));
	};

	//Handle CSV File Upload
	const handleFileLoad = (csvData, fileInputRef) => {
		const result = validateCSVHeaders(csvData, formik?.values?.type);
		if (!result?.isValid) {
			result?.errors?.forEach((error) => {
				toast.warning(error);
			});
		}
		setCSVData(result?.mappedHeaders);
	};

	//Handling states for different types of files.
	const [masterFileContent, setMasterFileContent] = React.useState({
		filePath: "",
		file: "",
		subtitleFile: "",
		subtitleFilePath: "",
	});

	const [trailerContent, setTrailerContent] = React.useState({
		filePath: "",
		file: "",
		subtitleFile: "",
		subtitleFilePath: "",
	});

	const [selectedPosterFiles, setSelectedPosterFiles] = React.useState([]);

	// Upload Files To S3 Function
	const uploadFile = async () => {
		try {
			const filePath = formik.values.filePath;
			const trailerFilePath = formik.values.trailerFilePath;
			const masterSubtitleFilePath = formik.values.masterSubtitleFilePath;
			const trailerSubtitleFilePath =
				formik.values.trailerSubtitleFilePath;

			if (filePath !== "it is DRM encoded!") {
				const isPdf = filePath.endsWith(".pdf");
				const contentType = isPdf ? "application/pdf" : undefined;

				await uploadData({
					key: filePath,
					data: masterFileContent.file,
					options: {
						contentType: contentType,
					},
				}).result;
				if (trailerFilePath) {
					await uploadData({
						key: trailerFilePath,
						data: trailerContent.file,
						options: {
							contentType: contentType,
						},
					}).result;
				}
			}
			if (masterSubtitleFilePath) {
				await uploadData({
					key: masterSubtitleFilePath,
					data: masterFileContent.subtitleFile,
				}).result;
			}
			if (trailerSubtitleFilePath) {
				await uploadData({
					key: trailerSubtitleFilePath,
					data: trailerContent.subtitleFile,
				}).result;
			}
		} catch (error) {
			console.error(
				"An error occurred during the upload process:",
				error
			);
		}
	};
	const uploadContentData = async () => {
		try {
			const posters = formik.values.posters;
			if (posters.length > 0) {
				console.log(`${posters.length} posters to upload.`);
				for (const [index, item] of posters.entries()) {
					console.log(`Uploading poster: ${item}`);
					const file = selectedPosterFiles[index];
					const result = await uploadData({
						key: item,
						data: file,
					}).result;
					console.log(result, "uploadData");
				}
			}
		} catch (error) {
			console.error(
				"An error occurred during the upload process:",
				error
			);
		}
	};

	//Post OneDrive Content To Backend Lambda Function
	const postOneDriveContent = async () => {
		try {
			const restOperation = post({
				apiName: "restapi123",
				path: "/onedriveuploader",
				options: {
					body: {
						oneDriveItems: selectedOneDriveFiles,
					},
				},
			});
			const { body } = await restOperation.response;
			const response = await body.json();
			return true;
		} catch (err) {
			console.log(err, "error");

			return false;
		}
	};

	//Handle Compliance Modal
	const handleOpen = () => dispatch(handleComplianceOpen(true));
	const handleClose = () => dispatch(handleComplianceOpen(false));

	const validationSchema = yup.object({
    title: yup.string().required("Title is required"),
    synopsis: yup.string().required("Synopsis is required"),
    posters: yup
        .array()
        .of(yup.string())
        .test(
            "has-valid-posters",
            "At least 1 poster required!",
            function(value) {
                // Check if posters array has valid entries (not empty strings)
                return value && value.length > 0 && value.some(poster => poster && poster.trim() !== "" && poster !== "undefined");
            }
        )
        .required("Posters are required!"),
    type: yup.string().required("Content type is required"),
    category: yup.string().required("Content Category is required!"),
    rating: yup
        .string()
        .test(
            "is-rating-required",
            "Viewership Rating is required!",
            function (value, context) {
                const { type, category } = this.parent;
                // Skip rating requirement for Devotion content
                if (type === DEVOTION) return true;
                
                // Always require rating for DreamKids content
                if (category === DREAMKIDS) {
                    return !!value;
                }
                
                return !!value; // Required for other content types
            }
        ),
    imdbRating: yup
        .string()
        .test(
            "is-imdb-required",
            "IMDB Rating is required!",
            function (value, context) {
                const { type, category } = this.parent;
                // Skip IMDB rating for these content types
                if ([DEVOTION, LISTEN, READ].includes(type)) return true;
                
                // Optional for Vodcast
                if (category === VODCAST) return true;
                
                return !!value; // Required for other Watch content
            }
        ),
    rottenRating: yup
        .string()
        .test(
            "is-rotten-rating-required",
            "Rotten Rating is required!",
            function (value, context) {
                const { type, category } = this.parent;
                // Skip Rotten rating for these content types
                if ([DEVOTION, LISTEN, READ].includes(type)) return true;
                
                // Optional for Vodcast
                if (category === VODCAST) return true;
                
                return !!value; // Required for other Watch content
            }
        ),
    director: yup
        .string()
        .test(
            "is-director-required",
            "Director is required!",
            function (value, context) {
                const { type, category } = this.parent;
                // Skip director for these content types
                if ([DEVOTION, LISTEN, READ].includes(type)) return true;
                
                // Optional for Vodcast
                if (category === VODCAST) return true;
                
                return !!value; // Required for other Watch content
            }
        ),
    host: yup
        .string()
        .test(
            "is-host-required",
            "Host is required for Vodcast content!",
            function (value, context) {
                const { category } = this.parent;
                
                // Required for Vodcast
                if (category === VODCAST) {
                    return !!value;
                }
                
                return true; // Not required for other content
            }
        ),
    genre: yup
        .array()
        .of(yup.string())
        .min(1, "At least 1 genre is required!")
        .test(
            "is-genre-required",
            "Genres are required!",
            function (value, context) {
                const { type } = this.parent;
                return (
                    type === DEVOTION ||
                    (value?.length && !value.includes(undefined))
                );
            }
        ),
    language: yup
        .string()
        .test(
            "is-language-required",
            "Language is required!",
            function (value, context) {
                const { type } = this.parent;
                return [DEVOTION, LISTEN].includes(type) || !!value;
            }
        ),
    country: yup
        .string()
        .test(
            "is-country-required",
            "Country is required!",
            function (value, context) {
                const { type } = this.parent;
                // Skip country requirement for specific content types if needed
                return !!value; // Required for most content types
            }
        ),
    filePath: yup
        .string()
        .test(
            "file-upload-check",
            "Master file has not been uploaded yet!",
            function(value) {
                const { isOneDrive } = this.parent;
                
                // Enhanced validation for OneDrive and local uploads
                if (isOneDrive) {
                    // For OneDrive uploads, check if we have a valid file path
                    return value && 
                           value.trim() !== "" && 
                           value !== "Master file has not been uploaded yet!" &&
                           !value.includes("undefined");
                }
                
                // For local uploads, ensure file path exists and is valid
                return value && 
                       value.trim() !== "" && 
                       value !== "Master file has not been uploaded yet!";
            }
        )
        .required("Master file has not been uploaded yet!"),
    year: yup
        .number()
        .when('type', {
            is: DEVOTION,
            then: schema => schema.optional(),
            otherwise: schema => schema.required("Year is required!")
        }),
    duration: yup
        .number()
        .test(
            "is-duration-required",
            "Duration is required!",
            function (value, context) {
                const { type } = this.parent;
                return type === READ || !!value;
            }
        )
        .required("Duration is required!"),
});


	//Function to handle edit content
	const handleUpdateContent = async (values) => {
		try {
			dispatch(setLoading(true));
			const inputValues = { ...values };
			if (!isSeries) {
				delete inputValues.SeasonId;
				delete inputValues.seriesId;
			}

			const response = await client.graphql({
				query: updateContent,
				variables: {
					input: {
						id: params?.contentId,
						...inputValues,
						isDrmProtected: false,
						isSeries: false,
					},
				},
			});
			if (response.data.updateContent?.isOneDrive) {
				const onedriveResponse = await postOneDriveContent();
			}

			if (response.data.updateContent) {
				dispatch(resetOnedrive());
				dispatch(setOMDbContent(null));
				dispatch(setReadContent(null));		
				handleSuccessModal(); 
			}
		} catch (error) {
			dispatch(
				handleSuccessState({
					success: false,
					message: error.message,
					openModal: true,
				})
			);
		} finally {
			dispatch(setLoading(false));
		}
	};

	const params = useParams();

	//Formik
	const formik = useFormik({
		initialValues: {
			agreementId: agreementDetails?.id,
			status: contentForm?.status || "Pending",
			title: contentForm?.title || "",
			type: contentForm?.type || "",
			category: contentForm?.category || "",
			currentCycle:
				contentForm?.currentCycle || params?.currentCycle || 1,
			imdbRating: contentForm?.imdbRating || "",
			rottenRating: contentForm?.rottenRating || "",
			rating: contentForm?.rating || "",
			genre: contentForm?.genre || [""],
			language: contentForm?.language || "",
			duration: contentForm?.duration || 0,
			author: contentForm?.author || "",
			publisher: contentForm?.publisher || "",
			filePath: contentForm?.filePath || "",
			trailerFilePath: contentForm?.trailerFilePath || "",
			masterSubtitleFilePath: contentForm?.masterSubtitleFilePath || "",
			trailerSubtitleFilePath: contentForm?.trailerSubtitleFilePath || "",
			country: contentForm?.country || "",
			synopsis: contentForm?.synopsis || "",
			year: contentForm?.year || "",
			composer: contentForm?.composer || "",
			artist: contentForm?.artist || "",
			director: contentForm?.director || "",
			actors: contentForm?.actors || [""],
			posters: contentForm?.posters || [""],
			SeasonId: contentForm?.seasonId || "",
			seriesId: contentForm?.seriesId || "",
			studios: [""],
		},
		validationSchema: validationSchema,
		onSubmit: async (values) => {
			if (!complianceChecked) {
				handleOpen();
				return;
			}
			if (isEditMode) {
				await handleUpdateContent(values);
				return;
			}

			try {
				dispatch(setLoading(true));
				await uploadFile();
				await uploadContentData();

				const inputValues = { ...values };
				if (!isSeries) {
					delete inputValues.SeasonId;
					delete inputValues.seriesId;
				}

				if (values?.isOneDrive) {
					const onedriveResponse = await postOneDriveContent();
					if (onedriveResponse) {
						const response = await client.graphql({
							query: createContent.replaceAll("__typename", ""),
							variables: {
								input: {
									...inputValues,
									isDrmProtected: false,
									isSeries,
								},
							},
						});
						if (response.data.createContent) {
							dispatch(resetOnedrive());
							dispatch(setOMDbContent(null));
							dispatch(setReadContent(null));
							dispatch(clearContentForm());

							// formik.resetForm();
							// navigate("/content/content-success");
							handleSuccessModal();
						}
						if (response.errors) {
							toast.error("Internal Server Error!");
						}
					} else {
						throw new Error(
							"Failed to upload content! Please try again."
						);
					}
				} else {
					const response = await client.graphql({
						query: createContent.replaceAll("__typename", ""),
						variables: {
							input: {
								...inputValues,
								isDrmProtected: false,
								isSeries,
							},
						},
					});
					if (response.data.createContent) {
						dispatch(setOMDbContent(null));
						dispatch(setReadContent(null));
						dispatch(clearContentForm());

						// formik.resetForm();
						// navigate("/content/content-success");
						handleSuccessModal();
					}
				}
			} catch (err) {
				console.log(err?.message, "uploading error message");
				dispatch(
					handleSuccessState({
						success: false,
						openModal: true,
						message: err?.message,
					})
				);
			} finally {
				dispatch(setLoading(false));
			}
		},
	});

	//Function for converting string to number for the time in string
	function convertToNumber(timeString) {
		const parts = timeString.split(" ");
		if (parts.length < 2) {
			return "Invalid input";
		}

		const minutes = parseInt(parts[0], 10);

		return minutes;
	}

	useEffect(() => {
		let genreValue = formik.values.genre;
		
		if (formik.values.type === DEVOTION && formik.values.category) {
		  if (formik.values.category === "Quran Majeed") {
			genreValue = ["Quran"];
		  } else {
			genreValue = ["Devotion"];
		  }
		} else {
		  // For non-DEVOTION content, use the existing logic for genre
		  genreValue = OMDbContent
			? OMDbContent?.Genre?.split(",").map((genre) => genre.trim())
			: readContent
			? readContent.genre
			: csvData
			? csvData?.genre?.[0]?.value
				?.split(",")
				.map((genre) => genre.trim())
			: formik.values.genre;
		}
	  
		formik.setValues({
		  ...formik.values,
		  
		  imdbRating: OMDbContent
			? OMDbContent?.imdbRating
			: csvData
			? csvData?.imdbRating?.[0]?.value
			: formik?.values?.imdbRating,
		  rottenRating:
			OMDbContent && OMDbContent.Ratings?.length > 2
			  ? OMDbContent.Ratings[1]?.Value
			  : csvData
			  ? csvData?.rottenRating?.[0]?.value
			  : formik?.values?.rottenRating,
			  country: csvData
    ? csvData?.country?.[0]?.value
    : formik.values.country,
		  rating: OMDbContent
			? OMDbContent?.Rated
			: csvData
			? csvData?.rating?.[0]?.value
			: formik.values.rating,
		  title: OMDbContent
			? OMDbContent.Title
			: csvData
			? csvData?.title?.[0]?.value
			: formik.values.title,
		  genre: genreValue, // Use the conditionally determined genre value
		  duration: OMDbContent
			? convertToNumber(OMDbContent?.Runtime || "00")
			: csvData
			? csvData?.duration?.[0]?.value
			: formik.values.duration,
		  synopsis: OMDbContent
			? OMDbContent?.Plot
			: readContent
			? readContent.synopsis
			: csvData
			? csvData?.description?.[0]?.value
			: formik.values.synopsis,
		  year: OMDbContent
			? OMDbContent.Year
			: readContent
			? moment(readContent.year).format("YYYY")
			: listenContent
			? moment(listenContent.year).format("YYYY")
			: csvData
			? csvData?.year?.[0]?.value
			: formik.values.year,
		  director: OMDbContent
			? OMDbContent.Director
			: csvData
			? csvData?.director?.[0]?.value
			: formik.values.director,
		  actors: OMDbContent
			? OMDbContent.Actors?.split(",").map((actor) => actor.trim())
			: csvData
			? csvData?.actors?.[0]?.value
				?.split(",")
				.map((actor) => actor.trim())
			: formik.values.actors,
		  author: readContent
			? readContent.authors
			: csvData
			? csvData?.authors?.[0]?.value
				?.split(",")
				.map((actor) => actor.trim())
			: formik.values.author,
		  publisher: readContent
			? readContent.publisher
			: csvData
			? csvData?.publisher?.[0]?.value
				?.split(",")
				.map((actor) => actor.trim())
			: formik.values.publisher,
		  artist: listenContent
			? listenContent.artist
			: csvData
			? csvData?.artist?.[0]?.value
			: formik.values.artist || "",
		  composer: listenContent
			? listenContent.composer
			: csvData
			? csvData?.composer?.[0]?.value
			: formik.values.composer || "",
		  studios:
			csvData?.studios?.[0]?.value
			  ?.split(",")
			  .map((genre) => genre.trim()) || formik.values.studios,
		});
	  }, [OMDbContent, readContent, listenContent, csvData, formik.values.type, formik.values.category]);

	  const handleContentManagers = () => {
		if (formik.values.type === READ) {
		  return (
			<Box>
			  {/* <Button variant="outlined">+ Add People</Button> */}
			  <InputText
				label={"Author"}
				value={formik.values.author}
				placeholder={"Author"}
				id={"author"}
				name={"author"}
				formik={formik}
			  />
			  <InputText
				label={"Publisher"}
				value={formik.values.publisher}
				placeholder={"Publisher"}
				id={"publisher"}
				name={"publisher"}
				formik={formik}
			  />
			</Box>
		  );
		} else if (formik.values.type === WATCH) {
		  if (formik.values.category === VODCAST) {
			return (
			  <Box>
				<InputText
				  label={"Host"}
				  value={formik.values.host}
				  placeholder={"Host"}
				  id={"host"}
				  name={"host"}
				  formik={formik}
				/>
				<InputText
				  label={"Director"}
				  value={formik.values.director}
				  placeholder={"Director"}
				  id={"director"}
				  name={"director"}
				  formik={formik}
				/>
				<InputText
				  label={"Guests"}
				  value={formik.values.guests}
				  placeholder={"Guests"}
				  id={"guests"}
				  name={"guests"}
				  formik={formik}
				/>
			  </Box>
			);
		  } else if (formik.values.category === DREAMKIDS) {
			return (
			  <Box>
				<InputText
				  label={"Director"}
				  value={formik.values.director}
				  placeholder={"Director"}
				  id={"director"}
				  name={"director"}
				  formik={formik}
				/>
				<InputText
				  label={"Actors"}
				  value={formik.values.actors}
				  placeholder={"Actors"}
				  id={"actors"}
				  name={"actors"}
				  formik={formik}
				/>
			  </Box>
			);
		  } else {
			return (
			  <Box>
				<InputText
				  label={"Director"}
				  value={formik.values.director}
				  placeholder={"Director"}
				  id={"director"}
				  name={"director"}
				  formik={formik}
				/>
				<InputText
				  label={"Actors"}
				  value={formik.values.actors}
				  placeholder={"Actors"}
				  id={"actors"}
				  name={"actors"}
				  formik={formik}
				/>
				{(formik.values.category === "Movies" || formik.values.category === SHORT_FILM) && (
				  <StudioSelector formik={formik} />
				)}
			  </Box>
			);
		  }
		} else if (formik.values.type === LISTEN) {
		  return (
			<Box>
			  {/* <Button variant="outlined">+ Add People</Button> */}
			  <InputText
				label={"Composer"}
				value={formik.values.composer}
				placeholder={"Composer"}
				id={"composer"}
				name={"composer"}
				formik={formik}
			  />
			  <InputText
				label={"Artist"}
				value={formik.values.artist}
				placeholder={"Artist"}
				id={"artist"}
				name={"artist"}
				formik={formik}
			  />
			</Box>
		  );
		} else {
		  return null;
		}
	  };

	const handleSaveNext = async () => {
		const formErrors = await formik.validateForm();
		console.log(formErrors, "formErrors");
		if (Object.keys(formErrors).length > 0) {
			// Set all fields as touched if there are errors
			formik.setTouched(
				Object.keys(formErrors).reduce((acc, key) => {
					acc[key] = true;
					return acc;
				}, {})
			);
		} else if (!complianceChecked && !addNewContentSteps?.completed[2]) {
			dispatch(handleComplete());
			dispatch(handleComplianceOpen(true));
		} else if (
			addNewContentSteps?.completed[1] &&
			addNewContentSteps?.completed[2]
		) {
			dispatch(handleNext());
		} else {
			// If no errors, proceed with the dispatch action
			dispatch(handleComplete());
		}
	};

	const contentSource = {
		masterFileContent,
		trailerContent,
		posters: selectedPosterFiles,
	};

	return (
		<>
			<NavigationWarningModal />
			<form onSubmit={formik.handleSubmit}>
				{addNewContentSteps?.activeStep === 4 ? (
					<ManifestPreview
						submit={true}
						contentValues={formik.values}
						loading={loading}
						localContentSource={contentSource}
					/>
				) : (
					<>
						{" "}
						<Box
							sx={{
								width: "100%",
								display: "flex",
								gap: "30px",
								justifyContent: "center",
							}}
						>
							<Box sx={{ maxWidth: "70%" }} flexBasis={"50%"}>
								<ContentType formik={formik} />
								<Category formik={formik} />
								{formik.values.type === DEVOTION ? (
									<>
										<Box>
											<MediaTypeSelector />
										</Box>
										<Box>
											<IsDevotionMultiple
												label={
													"Do you want to upload batch files for devotion content?"
												}
											/>
										</Box>
										{isDevotionMultiple && (
											<BatchDevotionHandler
												formik={formik}
											/>
										)}
									</>
								) : null}

                                {/* Updated series handler section */}
                                {(formik.values.category === "TV" || 
                                   formik.values.category === VODCAST || 
                                   formik.values.category === DREAMKIDS) && (
                                  <SeriesHandler
                                    formik={formik}
                                    isSeries={isSeries}
                                    selectedSeasonsList={selectedSeasonsList}
                                  />
                                )}
								
								{formik.values.category === "Music" && (
									<AlbumHandler formik={formik} />
								)}

{formik.values.category === "Podcasts" && (
									<AlbumHandler formik={formik} />
								)}

								{isSeries || isAlbum || isDevotionMultiple ? (
									<></>
								) : (
									<Box>
										{formik.values.category &&
											formik.values.type && (
												<Box
													display={"flex"}
													gap={1}
													justifyContent={
														"space-between"
													}
												>
													<h4>
														Enter content details
														manually OR Upload CSV
														file
													</h4>
													<CsvFileInput
														onFileLoad={
															handleFileLoad
														}
													/>
												</Box>
											)}
										<Title
											formik={formik}
											label={"Title"}
											id={"title"}
											setCSVData={setCSVData}
											placeholder={"Enter Title"}
										/>

										{handleContentManagers()}

										{formik.values.type === WATCH ? (
											<>
												<InputText
													label={"IMDB Rating"}
													placeholder={"IMDB Rating"}
													id={"imdbRating"}
													formik={formik}
													value={
														formik.values.imdbRating
													}
													name={"imdbRating"}
												/>
												<InputText
													label={
														"Rotten Tomatoes Rating"
													}
													placeholder={
														"Rotten Tomatoes Rating"
													}
													id={"rottenRating"}
													formik={formik}
													value={
														formik.values
															.rottenRating
													}
													name={"rottenRating"}
												/>
												<Rating formik={formik} />
											</>
										) : formik.values.type === DEVOTION ||
										  formik.values.type === PLAY ? (
											" "
										) : (
											<Rating formik={formik} />
										)}

										{formik.values.type === WATCH ||
										formik.values.type === READ ||
										formik.values.type === LISTEN ? (
											<>
												<InputText
													label={
														formik.values.type ===
														WATCH
															? "Production Year"
															: "Year Of Release"
													}
													value={formik.values.year}
													placeholder={
														formik.values.type ===
														WATCH
															? "Production Year"
															: "Year Of Release"
													}
													id={"year"}
													name={"year"}
													formik={formik}
													type={"number"}
												/>
												<Genre
													csvData={csvData}
													label={"Genre"}
													id={"genre"}
													formik={formik}
												/>
											</>
										) : null}

										<Language formik={formik} />
										<Country formik={formik} csvData={csvData} />

										{formik.values.type === LISTEN ||
										formik.values.type === WATCH ||
										formik.values.type === DEVOTION ? (
											<InputText
												label={"Duration (mins)"}
												placeholder={"Duration"}
												type="number"
												id={"duration"}
												formik={formik}
												value={formik.values.duration}
												name={"duration"}
											/>
										) : null}

										<InputText
											label={
												formik.values.type === DEVOTION
													? "Description"
													: "Synopsis"
											}
											placeholder={"Synopsis"}
											value={formik.values.synopsis}
											id={"synopsis"}
											name={"synopsis"}
											formik={formik}
											multiline={true}
										/>
									</Box>
								)}
							</Box>

							<Box flexBasis={"50%"}>
								<ReadOnlyInput
									label={"Number of Refresh Cycles"}
									value={
										agreementDetails?.numberOfRefreshCycles
									}
								/>
								<ReadOnlyInput
									label={"Number of Months Per Cycle"}
									value={`${agreementDetails?.numberOfMonthsPerCycle} months`}
								/>{" "}
								<Selector
									label={"Select the current cycle"}
									name={"currentCycle"}
									formik={formik}
									noneValue={"Select current cycle"}
									options={cyclesOptions}
								/>
								<ReadOnlyInput
									label={"Term of Agreement"}
									value={"3 months"}
								/>
								{!complianceChecked && (
									<ComplianceModal
										open={complianceOpen}
										handleClose={handleClose}
										formik={formik}
									/>
								)}
								<ContentSuccessModal
									open={submittedSuccessfully}
									onClose={handleCloseModal}
								/>
							</Box>
						</Box>
						{isAlbum && albumId ? (
							<UploadMultipleSongs formik={formik} />
						) : isSeries && selectedSeasonsList?.length > 0 ? (
							selectedSeasonsList.map((season) => (
								<UploadSeasonContent
									key={season.id}
									seasonId={season.id}
									title={season.title}
								/>
							))
						) : (
							<Box sx={{ width: "100%", marginTop: 5 }}>
								<UploadMetaData
									masterFileContent={masterFileContent}
									trailerContent={trailerContent}
									setMasterFileContent={setMasterFileContent}
									setTrailerContent={setTrailerContent}
									setSelectedPosterFiles={
										setSelectedPosterFiles
									}
									formik={formik}
								/>

								<Box
									marginTop={2}
									display={"flex"}
									justifyContent={"space-between"}
								>
									<Box display={"flex"} gap={2}>
										<Button
											onClick={() => {
												dispatch(resetOnedrive());
												dispatch(setOMDbContent(null));
												formik.resetForm();
											}}
											variant="contained"
											color="error"
										>
											Clear
										</Button>
										<Button
											onClick={() =>
												dispatch(handleBack())
											}
										>
											Back
										</Button>
									</Box>
									<Box>
										<Button
											onClick={handleSaveNext}
											sx={{
												backgroundColor:
													"primary.darker",
												color: "secondary.main",
											}}
											variant="contained"
										>
											Save and Next
										</Button>
									</Box>
								</Box>
							</Box>
						)}
					</>
				)}
			</form>
			<ContentSuccessModal
				open={contentSubmittedSuccessfully}
				formik={formik}
				onClose={() => {
					console.log("ads");
				}}
			/>
		</>
	);
};

export default CreateContent;